import { State, Action } from 'src/types'
import {
  SET_SELECTED_PARTS,
  SET_ALL_LEATHER_COLOR,
  SET_DOMINANT_ARM,
  SET_SIZE,
  SET_FINGER_GUARD_TYPE,
  SET_MATERIAL_PACK,
  SET_WEB_PARTS,
  SET_YELL_STORY_LABEL,
  SET_LEATHER_COLOR,
  SET_EDGE_COLOR,
  SET_LININGS,
  SET_HAMIDASHI,
  SET_LACE_COLOR,
  SET_STITCH_COLOR,
  SET_EMBROIDERIES,
  ADD_EMBROIDERY,
  REMOVE_EMBROIDERY,
  SET_WEB_COLOR,
  SET_WEB_COLOR_2,
  SET_THUMB_HOOK,
  SET_LITTLE_HOOK,
  SET_INDEX_COVER_COLOR,
  SET_PERSONAL,
  SET_THUMB_OUT_COLOR,
  SET_THUMB_WEB_COLOR,
  SET_INDEX_WEB_COLOR,
  SET_INDEX_MIDDLE_COLOR,
  SET_MIDDLE_INDEX_COLOR,
  SET_MIDDLE_RING_COLOR,
  SET_RING_MIDDLE_COLOR,
  SET_RING_LITTLE_COLOR,
  SET_LITTLE_RING_COLOR,
  SET_LITTLE_OUT_COLOR,
  SET_LIST_BELT_COLOR,
  SET_BASE_MODEL,
  SET_LEATHER_INTEGRATED_INDEX,
  SET_LEATHER_INTEGRATED_MIDDLE,
  SET_LEATHER_INTEGRATED_RING,
  SET_SERIES,
  SET_YSR_ORIGINAL_EMBROIDERY,
  SET_YSR_DIRECT_LOGO_1_POSITION,
  SET_YSR_DIRECT_LOGO_1_MAIN_COLOR,
  SET_YSR_DIRECT_LOGO_2_POSITION,
  SET_YSR_DIRECT_LOGO_2_COLOR,
  SET_YSR_DIRECT_LOGO_1_EDGE_COLOR,
  SET_FIGURE_PANEL_NUMBER
} from 'src/features/yellStory/constants/actionType'
import {
  baseInitialState,
  gloveColorInitialState,
  initialEmbroideryState,
  initialPersonalState,
  unselectedColorState,
  unselectedState,
  initialGloveImagesState
} from 'src/constants'
import { ysrDirectLogo1LabelObj } from 'src/features/yellStory/constants/colors'

const colorInitialState = {
  parts: { label: '全体', value: 'all' },
  all: unselectedColorState,
  catchFace: unselectedColorState,
  edge: unselectedColorState,
  lace: unselectedColorState,
  linings: unselectedColorState,
  hamidashi: unselectedColorState,
  stitch: { label: '未選択', value: 'unselected', color: '#eee' },
  web: unselectedColorState,
  web2: unselectedColorState,
  thumbHook: unselectedColorState,
  littleHook: unselectedColorState,
  listBelt: unselectedColorState,
  indexCover: unselectedColorState
}

export const initialInfielderState: State = {
  ...baseInitialState,
  series: unselectedState,
  dominantArm: { label: '右投げ', value: 'rightThrow' },
  leatherIntegratedIndex: unselectedState,
  leatherIntegratedMiddle: unselectedState,
  leatherIntegratedRing: unselectedState,
  webParts: unselectedState,
  materialPack: unselectedState,
  ysrLabel: unselectedState,
  ysrOriginalEmbroidery: unselectedState,
  ysrDirectLogo1Position: unselectedState,
  ysrDirectLogo1MainColor: unselectedState,
  ysrDirectLogo1EdgeColor: unselectedState,
  ysrDirectLogo2Position: unselectedState,
  ysrDirectLogo2Color: unselectedState,
  ...colorInitialState,
  ...gloveColorInitialState,
  embroideries: [initialEmbroideryState],
  personal: initialPersonalState,
  figurePanelNum: 1,
  images: initialGloveImagesState
}

export const infieldReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case SET_BASE_MODEL:
      return { ...state, baseModel: action.baseModel }
    case SET_SERIES:
      return { ...state, series: action.series }
    case SET_DOMINANT_ARM:
      return { ...state, dominantArm: action.dominantArm }
    case SET_SIZE:
      return { ...state, size: action.size }
    case SET_FINGER_GUARD_TYPE:
      return { ...state, fingerGuardType: action.fingerGuardType, figurePanelNum: 1 }
    case SET_LEATHER_INTEGRATED_INDEX:
      return { ...state, leatherIntegratedIndex: action.leatherIntegratedIndex, figurePanelNum: 1 }
    case SET_LEATHER_INTEGRATED_MIDDLE:
      return { ...state, leatherIntegratedMiddle: action.leatherIntegratedMiddle, figurePanelNum: 1 }
    case SET_LEATHER_INTEGRATED_RING:
      return { ...state, leatherIntegratedRing: action.leatherIntegratedRing, figurePanelNum: 1 }
    case SET_MATERIAL_PACK:
      return { ...state, materialPack: action.materialPack, figurePanelNum: 0 }
    case SET_WEB_PARTS:
      return { ...state, webParts: action.webParts }
    case SET_SELECTED_PARTS:
      return { ...state, parts: action.parts }
    case SET_ALL_LEATHER_COLOR:
      return {
        ...state,
        all: action.all,
        catchFace: action.all,
        web: action.all,
        web2: action.all,
        thumbHook: action.all,
        littleHook: action.all,
        edge: action.all,
        indexCover: action.all,
        listBelt: action.all,
        linings: action.all,
        thumbOut: action.all,
        thumbWeb: action.all,
        indexWeb: action.all,
        indexMiddle: action.all,
        middleIndex: action.all,
        middleRing: action.all,
        ringMiddle: action.all,
        ringLittle: action.all,
        littleRing: action.all,
        littleOut: action.all
      }
    case SET_YELL_STORY_LABEL:
      return { ...state, ysrLabel: action.ysrLabel, figurePanelNum: 1 }
    case SET_YSR_ORIGINAL_EMBROIDERY:
      return { ...state, ysrOriginalEmbroidery: action.ysrOriginalEmbroidery }
    case SET_YSR_DIRECT_LOGO_1_POSITION: {
      const ysrDirectLogo1Position = action.ysrDirectLogo1Position
      const ysrLabel =
        ysrDirectLogo1Position.value === 'band'
          ? ysrDirectLogo1LabelObj
          : state.ysrLabel?.value === ysrDirectLogo1LabelObj.value
            ? unselectedState
            : state.ysrLabel
      const isNone = ysrDirectLogo1Position.value === 'none'
      return {
        ...state,
        ysrDirectLogo1Position,
        ysrLabel,
        ysrDirectLogo1MainColor: isNone ? unselectedState : state.ysrDirectLogo1MainColor,
        ysrDirectLogo1EdgeColor: isNone ? unselectedState : state.ysrDirectLogo1EdgeColor,
        figurePanelNum: 1
      }
    }
    case SET_YSR_DIRECT_LOGO_1_MAIN_COLOR:
      return { ...state, ysrDirectLogo1MainColor: action.ysrDirectLogo1MainColor, figurePanelNum: 1 }
    case SET_YSR_DIRECT_LOGO_1_EDGE_COLOR:
      return { ...state, ysrDirectLogo1EdgeColor: action.ysrDirectLogo1EdgeColor, figurePanelNum: 1 }
    case SET_YSR_DIRECT_LOGO_2_POSITION: {
      const ysrDirectLogo2Position = action.ysrDirectLogo2Position
      const isNone = ysrDirectLogo2Position.value === 'none'
      return {
        ...state,
        ysrDirectLogo2Position,
        ysrDirectLogo2Color: isNone ? unselectedState : state.ysrDirectLogo2Color,
        figurePanelNum: 1
      }
    }
    case SET_YSR_DIRECT_LOGO_2_COLOR:
      return { ...state, ysrDirectLogo2Color: action.ysrDirectLogo2Color, figurePanelNum: 1 }
    case SET_LEATHER_COLOR:
      return { ...state, catchFace: action.catchFace }
    case SET_EDGE_COLOR:
      return { ...state, edge: action.edge }
    case SET_WEB_COLOR:
      return { ...state, web: action.web }
    case SET_WEB_COLOR_2:
      return { ...state, web2: action.web2 }
    case SET_THUMB_OUT_COLOR:
      return { ...state, thumbOut: action.thumbOut }
    case SET_THUMB_WEB_COLOR:
      return { ...state, thumbWeb: action.thumbWeb }
    case SET_INDEX_WEB_COLOR:
      return { ...state, indexWeb: action.indexWeb }
    case SET_INDEX_MIDDLE_COLOR:
      return { ...state, indexMiddle: action.indexMiddle }
    case SET_MIDDLE_INDEX_COLOR:
      return { ...state, middleIndex: action.middleIndex }
    case SET_MIDDLE_RING_COLOR:
      return { ...state, middleRing: action.middleRing }
    case SET_RING_MIDDLE_COLOR:
      return { ...state, ringMiddle: action.ringMiddle }
    case SET_RING_LITTLE_COLOR:
      return { ...state, ringLittle: action.ringLittle }
    case SET_LITTLE_RING_COLOR:
      return { ...state, littleRing: action.littleRing }
    case SET_LITTLE_OUT_COLOR:
      return { ...state, littleOut: action.littleOut }
    case SET_LIST_BELT_COLOR:
      return { ...state, listBelt: action.listBelt }
    case SET_LININGS:
      return { ...state, linings: action.linings, figurePanelNum: 1 }
    case SET_HAMIDASHI:
      return { ...state, hamidashi: action.hamidashi }
    case SET_LACE_COLOR:
      return { ...state, lace: action.lace }
    case SET_STITCH_COLOR:
      return { ...state, stitch: action.stitch }
    case SET_EMBROIDERIES:
      return { ...state, embroideries: action.embroideries, figurePanelNum: 1 }
    case ADD_EMBROIDERY: // incrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case REMOVE_EMBROIDERY: // decrementの方が合っている気がする
      return { ...state, embroideries: action.embroideries }
    case SET_THUMB_HOOK:
      return { ...state, thumbHook: action.thumbHook }
    case SET_LITTLE_HOOK:
      return { ...state, littleHook: action.littleHook }
    case SET_INDEX_COVER_COLOR:
      return { ...state, indexCover: action.indexCover }
    case SET_PERSONAL:
      return { ...state, personal: action.personal }
    case SET_FIGURE_PANEL_NUMBER:
      return { ...state, figurePanelNum: action.figurePanelNum }
    default:
      return state
  }
}
